import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Auth } from '@angular/fire/auth';
import { BusinessService, Constants, AppService, User, UserService } from 'briteatlib';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { combineLatest } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'brt-header-menu',
  standalone: true,
  imports: [MenuModule],
  templateUrl: './header-menu.component.html',
  styleUrl: './header-menu.component.scss'
})
export class HeaderMenuComponent {
  isOpen = false;
  user: User;
  menuItems: MenuItem[];

  constructor(private auth: Auth, userService: UserService, appService: AppService, private businessService: BusinessService) {
    combineLatest([appService.activeBusiness$, userService.current$])
      .pipe(takeUntilDestroyed()).subscribe(([business, user]) => this.load(business, user));
  }



  private load(business: any, user: any): void {
    this.user = user;
    this.menuItems = [
      {
        items: [
          {
            label: 'Home',
            icon: 'pi pi-home',
            routerLink: '/',
          },
        ]
      },
    ];

    if (user) {
      const staff = business?.Staffs?.find(_ => _.UserId == user.Id && !_.IsDisabled);
      const accountItems: MenuItem[] = [
        {
          label: 'My profile',
          icon: 'pi pi-user',
          routerLink: '/profile',
        },
        {
          label: 'My orders',
          icon: 'pi pi-shopping-cart',
          routerLink: '/order',
        },
      ];

      if (staff) {
        accountItems.unshift({
          label: 'Dashboard',
          icon: 'pi pi-chart-bar',
          url: this.dashboardUrl,
          target: '_self',
        });
      }

      this.menuItems.push({
        label: 'My Account',
        items: accountItems
      });

      if (staff)
        this.menuItems.push({ label: 'Management', items: this.businessService.getManagementMenuItems(business, staff) });
    }


    this.menuItems.push({
      separator: true,
      items: [
        { label: 'Contact us', icon: 'pi pi-envelope', routerLink: '/contact' },
        { label: 'About us', icon: 'pi pi-info', routerLink: '/about' },
        { label: 'Terms of use', icon: 'pi pi-lock', routerLink: '/terms' },
      ]
    });

    if (user) {
      this.menuItems.push({
        separator: true,
        items: [{
          label: 'Sign out',
          icon: 'pi pi-sign-out',
          command: () => this.signOut()
        }]
      });

    }
  }

  private get dashboardUrl(): string {
    if (environment.env === 'staging') return `https://dashboard-${environment.host}`;
    if (environment.production) return `https://dashboard.${environment.host}`;
    return `${window.location.protocol}//${window.location.hostname}:4352`;
  }

  signOut() {
    this.auth.signOut();
    window.location.reload();
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;
  }
}
